/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  Genetics,
  GeneticsInterface,
  GeneticsConstructor,
} from "../Genetics";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "maleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "femaleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32[13]",
            name: "geneticSequenceSignature",
            type: "uint32[13]",
          },
          {
            internalType: "uint32[72]",
            name: "maxValues",
            type: "uint32[72]",
          },
        ],
        internalType: "struct GeneticsConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "arithmeticMutation",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "uint32",
        name: "maleGenesProbability",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "femaleGenesProbability",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "inversionMutation",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence1",
        type: "uint32[72]",
      },
      {
        internalType: "uint32[72]",
        name: "geneticSequence2",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "mixGenes",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "scrambleMutation",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "maleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "femaleGenesProbability",
            type: "uint32",
          },
          {
            internalType: "uint32[13]",
            name: "geneticSequenceSignature",
            type: "uint32[13]",
          },
          {
            internalType: "uint32[72]",
            name: "maxValues",
            type: "uint32[72]",
          },
        ],
        internalType: "struct GeneticsConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "swapMutation",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence1",
        type: "uint32[72]",
      },
      {
        internalType: "uint32[72]",
        name: "geneticSequence2",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "uniformCrossover",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence1",
        type: "uint32[72]",
      },
      {
        internalType: "uint32[72]",
        name: "geneticSequence2",
        type: "uint32[72]",
      },
    ],
    name: "wholeArithmeticRecombination",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type GeneticsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GeneticsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Genetics__factory extends ContractFactory {
  constructor(...args: GeneticsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Genetics";
  }

  deploy(
    input: GeneticsConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Genetics> {
    return super.deploy(input, overrides || {}) as Promise<Genetics>;
  }
  getDeployTransaction(
    input: GeneticsConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): Genetics {
    return super.attach(address) as Genetics;
  }
  connect(signer: Signer): Genetics__factory {
    return super.connect(signer) as Genetics__factory;
  }
  static readonly contractName: "Genetics";
  public readonly contractName: "Genetics";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GeneticsInterface {
    return new utils.Interface(_abi) as GeneticsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Genetics {
    return new Contract(address, _abi, signerOrProvider) as Genetics;
  }
}
